<div class="row selected-filters">
  <div class="col ">
    <mat-form-field>
      <mat-label>PERÍODO</mat-label>
      <mat-select (selectionChange)="emit()" [(value)]="dateSelected">
        <mat-option [value]="item.value" *ngFor="let item of dates">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col">
    <mat-form-field>
      <mat-label>REGIÃO</mat-label>
      <mat-select (selectionChange)="emit()" [(value)]="regionSelected">
        <mat-option [value]="item.value" *ngFor="let item of regions">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col">
    <mat-form-field>
      <mat-label>MODELO E ANO</mat-label>
      <mat-select (selectionChange)="emit()" [(value)]="versionSelected">
        <mat-option [value]="item.value" *ngFor="let item of versions">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col">
    <mat-form-field>
      <mat-label>BASE PARA COMPARAÇÃO</mat-label>
      <mat-select (selectionChange)="emit()" [(value)]="groupSelected">
        <mat-option [value]="item.value" *ngFor="let item of groups">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
